/**
 * A module of methods that you want to include in all actions.
 * This module is consumed by `createAction`.
 */
"use strict";

module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/reflux/~/reflux-core/lib/ActionMethods.js
 ** module id = 340
 ** module chunks = 0
 **/